import { render } from "./RequestDetail.vue?vue&type=template&id=899e32aa&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&lang=js"
export * from "./RequestDetail.vue?vue&type=script&lang=js"

import "@/assets/css/layout_request.css?vue&type=style&index=0&id=899e32aa&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899e32aa"]])

export default __exports__